'use strict';

angular.module('user')
    .controller('UserProfilePasswordFormController', ['$q', 'AccountManager', 'ShareCrfApiErrorCodes', function($q, AccountManager, ShareCrfApiErrorCodes) {
        var vm = this;

        vm.ready = false;
        vm.data = {};

        vm.$onInit = function() {
            return AccountManager.init()
                .then(function() {
                    vm.ready = true;

                    /**
                     * Submit form
                     *
                     * @param {Form}
                     *
                     * @return {Promise}
                     */
                    vm.submit = function(form) {
                        vm.submitted = true;
                        vm.error = false;
                        vm.success = false;

                        var promise = $q.resolve();

                        if (form.$valid) {
                            vm.running = true;

                            var data = _.clone(vm.data);

                            promise = AccountManager.updatePassword(data.currentPassword, data.newPassword)
                                .then(function() {
                                    vm.running = false;
                                    vm.success = true;

                                    // Reset form
                                    vm.submitted = false;
                                    vm.data = {};
                                    form.$setPristine();
                                    form.$setUntouched();
                                })
                                .catch(function(error) {
                                    vm.running = false;
                                    vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                                });
                        }

                        return promise;
                    };
                });
        };

        vm.checkPassword = function(value) {
            return vm.data.newPassword === value;
        };
    }]);
